// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2cTEM","alert":"SettungsInbox_alert__204QQ"};